import {css} from 'lit';
export const styles = css`:host {
  display: block;
}

.main-header,
main,
footer {
  display: flex;
  align-items: center;
}

.main-header > *:not(:last-child), main > *:not(:last-child), footer > *:not(:last-child) {
    margin-right: 8px;
  }

.main-header {
  justify-content: space-between;
  align-items: baseline;
}

.main-header > h4 {
    margin-top: 0;
    margin-bottom: 0;
    font-size: 1.2em;
    font-weight: 600;
  }

main {
  margin-top: 8px;
  margin-bottom: 8px;
  padding: 8px 16px;
  border: 1px solid var(--border-light-secondary);
  border-radius: var(--border-radius);
  font-size: 0.9em;
}

main > ef-icon {
    font-size: 1.2em;
    margin-right: 8px;
  }

.sub-header,
footer {
  flex-wrap: wrap;
  font-size: 0.9em;
  color: var(--dark-text-secondary);
}

a {
  font-weight: 700;
}

.broken {
  border-color: var(--danger);
  color: var(--danger);
}

.working {
  border-color: var(--primary);
  color: var(--primary);
}

.inactive {
  border-color: var(--warning);
  color: var(--warning);
}
`;
export default styles;
